function loadFile<T extends string>(file: File): Promise<T>;
function loadFile<T extends string>(file: File, asText: true): Promise<T>;
function loadFile<T extends ArrayBuffer>(file: File, asText: false): Promise<T>;
function loadFile<T extends string | ArrayBuffer>(file: File, asText: boolean = true): Promise<T> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result as T);
        reader.onerror = () => reject(reader.error);

        if (asText) {
            reader.readAsText(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    });
}

export const FileUtils = {
    loadFile
}

export default FileUtils;